import Component from '../core/Component';
import throttle from 'lodash/throttle';

export default class Nav extends Component {
    constructor(element) {
        super(element);
        this.mobile = false;

        if (window.innerWidth < 1200) {
            this.mobile = true;
        }
    }

    prepare() {
        this.resizeHandler = throttle(::this.resize);

        this.ref.decorations.forEach(item => {
            item.multiplier = JSON.parse(item.dataset.multiplier);
            item.multiplier = JSON.parse(item.dataset.multiplier);
        });

        //this.mouseMoveHandler = throttle(::this.mouseMove);
        //this.scroller.on('scroll', ::this.scroll);
        // this.element.addEventListener('mousemove', ::this.mouseMoveHandler);
        window.addEventListener('resize', this.resizeHandler);

        this.resizeHandler();
        // this.mouseMoveHandler();
    }

    destroy() {
        //window.removeEventListener('mousemove', ::this.mouseMoveHandler);
        window.removeEventListener('resize', this.resizeHandler);
    }

    resize(event) {
        var body = document.body, html = document.documentElement;
        this.docHeight = Math.max( body.scrollHeight, body.offsetHeight, html.clientHeight, html.scrollHeight, html.offsetHeight );
        this.windowWidth = window.innerWidth;
        this.windowHeight = window.innerHeight;
        this.height = this.docHeight - this.element.offsetHeight;
    }

    mouseMove(event) {
        if (event == null) {
            return;
        }

        let mouseX = Math.round(event.clientX/this.windowWidth*1000)/10;
        let mouseY = Math.round(event.clientY/this.windowHeight*1000)/10;

        let globalMultiplier = .2;

        // move decorations
        this.ref.decorations.forEach(item => {
            let x = mouseX*item.multiplier.x * globalMultiplier;
            let y = mouseY*item.multiplier.y * globalMultiplier;
            let rx = mouseX*(mouseY/100)*item.multiplier.r * globalMultiplier;
            let ry = mouseY*item.multiplier.r * globalMultiplier;
            //item.style.transform = `translate3d(${-x}px, ${y}px, 0) rotateX(${rx}deg) rotateY(${ry}deg)`;
            //item.style.transform = `translate3d(${-x}px, ${y}px, 0) rotate(${rx}deg)`;
        });

        // set scroll
        //this.ref.container.style.transform = `translate3d(${-1*(this.height-(this.windowWidth/this.windowHeight*700))*percent/(100)}px, 0, 0)`;
    }

    mobileScroll(event) {
        let percent = Math.round(this.element.scrollLeft/this.mobileWidth*1000)/10;
        //console.log(percent)

        // move decorations
        this.ref.decorations.forEach(item => {
            let x = percent*item.multiplier.x;
            let y = percent*item.multiplier.y;
            let r = percent*item.multiplier.r;
            //item.style.transform = `translate3d(${x*.3}px, ${y*.3}px, 0) rotate(${r*.3}deg)`;
        });
    }

    open() {
        //this.loop = setInterval(() => {
        //
        //})
    }
}


// WEBPACK FOOTER //
// ./components/Nav.js